import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form } from "semantic-ui-react";
import "./button_informed.css";
import "./list_informed.css";
import ControlTitle from "../ControlTitle";

class NumberField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calc: "",
      value: ""
    };

    this.isFocused = false;
  }

  shouldComponentUpdate(nextProps) {
    const different =
      this.props.element_value !== nextProps.element_value ||
      this.props.error !== nextProps.error ||
      this.props.validate !== nextProps.validate;
    return different;
  }

  handleChange(calc, e) {
    let value = e.target.value;
    const { element_value, element_params } = this.props;
    let ceil = element_params.H;
    let floor = element_params.L;
    let increment = element_params.I;
    let dec = element_params.D;
    calc = calc.replace("+1", "+" + increment);
    calc = calc.replace("-1", "-" + increment);
    let ok = true;

    if (ceil !== undefined) {
      ceil = Number(ceil);
    }

    if (floor !== undefined) {
      floor = Number(floor);
    }

    if (ok) {
      if (calc != "") {
        if (Number(element_value) + Number(calc) > ceil) {
          ok = false;
          this.setState({ calc: calc, value: ceil.toString() });
          this.props.onChange(
            this.props.repeatingForm === undefined
              ? false
              : this.props.repeatingForm,
            this.props.element_id,
            ceil.toString()
          );
        }

        if (Number(element_value) + Number(calc) < floor) {
          ok = false;
          this.setState({ calc: calc, value: floor.toString() });

          this.props.onChange(
            this.props.repeatingForm === undefined
              ? false
              : this.props.repeatingForm,
            this.props.element_id,
            floor.toString()
          );
        }

        if (ok) {
          this.props.onChange(
            this.props.repeatingForm === undefined
              ? false
              : this.props.repeatingForm,
            this.props.element_id,
            (Number(element_value) + Number(calc)).toFixed(dec).toString()
          );
        }
      } else {
        this.setState({ calc: calc, value: value });

        this.props.onChange(
          this.props.repeatingForm === undefined
            ? false
            : this.props.repeatingForm,
          this.props.element_id,
          value
        );
      }
    }
  }

  onBlur() {
    if (this.isFocused) {
      let calc = this.state.calc;
      let value = this.state.value;
      const { element_params } = this.props;
      let okay = true;

      let ceil = element_params.H;
      let floor = element_params.L;
      let increment = element_params.I;
      let dec = element_params.D;
      calc = calc.replace("+1", "+" + increment);
      calc = calc.replace("-1", "-" + increment);

      if (ceil !== undefined) {
        ceil = Number(ceil);
      }

      if (floor !== undefined) {
        floor = Number(floor);
      }

      if (value > ceil) {
        okay = false;
        this.setState({ value: ceil });
        this.props.onChange(
          this.props.repeatingForm === undefined
            ? false
            : this.props.repeatingForm,
          this.props.element_id,
          ceil.toString()
        );

        window.alert("Number must be less than " + (ceil + 1).toString() + ".");
      }
      if (value < floor && value !== "") {
        okay = false;
        this.setState({ value: floor });
        this.props.onChange(
          this.props.repeatingForm === undefined
            ? false
            : this.props.repeatingForm,
          this.props.element_id,
          floor.toString()
        );
        this.setState({ value: floor.toString() });
        window.alert(
          "Number must be greater than " + (floor - 1).toString() + "."
        );
      }

      if (okay) {
        this.isFocused = false;
      } else {
        this.refs.tab1.focus();
        this.isFocused = false;
        window.setTimeout(() => {
          this.isFocused = true;
        }, 0);
      }
    }
  }

  onFocus() {
    this.isFocused = true;
  }

  renderInput() {
    const { element_value, validate, error } = this.props;

    if (validate && error) {
      return (
        <input
          type="number"
          ref="tab1"
          className="number error"
          value={element_value}
          onChange={this.handleChange.bind(this, "")}
        />
      );
    }

    return (
      <input
        type="number"
        ref="tab1"
        onFocus={() => this.onFocus()}
        onBlur={() => this.onBlur()}
        className="number"
        value={element_value}
        onChange={this.handleChange.bind(this, "")}
      />
    );
  }
  render() {
    const { element_prompt, element_value, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          <table>
            <tbody>
              <tr>
                <td>{this.renderInput()}</td>
                <td>
                  <button
                    className="ui button numberButton"
                    onClick={this.handleChange.bind(this, "-1")}
                  >
                    <i
                      style={{ position: "relative", top: "1px" }}
                      className="minus icon"
                    ></i>
                  </button>
                </td>
                <td>
                  <button
                    className="ui button numberButton"
                    onClick={this.handleChange.bind(this, "+1")}
                  >
                    <i
                      style={{ position: "relative", top: "1px" }}
                      className="plus icon"
                    ></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </Form.Field>
      </div>
    );
  }
}

NumberField.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default NumberField;



// WEBPACK FOOTER //
// ./src/components/NumberField/index.js